import { render, staticRenderFns } from "./UpdateCompanyForm.vue?vue&type=template&id=19ec5a7b&"
import script from "./UpdateCompanyForm.vue?vue&type=script&lang=js&"
export * from "./UpdateCompanyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports